import {useNavigate} from "react-router-dom";
import LongArrowRight from "../../assets/icons/LongArrowRight";
import React from "react";
import "./breadcrumbs.css";

export interface BreadcrumbProps {
    label: string;
    pathname?: string;
}

export interface BreadcrumbsProps {
    breadcrumbs?: BreadcrumbProps[];
}

const Breadcrumbs = ({ breadcrumbs }: BreadcrumbsProps) => {
    const navigate = useNavigate();

    const onBreadcrumbClick = (bc: BreadcrumbProps) => () => {
        if(bc.pathname) {
            navigate(bc.pathname);
        }
    }

    if(!breadcrumbs?.length) return null;

    return <div className="breadcrumbs">
        {breadcrumbs.map((bc: BreadcrumbProps, index: number) => <div key={`breadcrumb-${bc.label}-${index}`} className="breadcrumb-container">
            <div className={`breadcrumb ${bc.pathname ? 'linked' : ''}`} onClick={onBreadcrumbClick(bc)}>
                {bc.label}
            </div>
            {index < breadcrumbs.length - 1 ? <LongArrowRight width={8} height={8} color="#9e9e9e" /> : null}
        </div>)}
    </div>

}

export default Breadcrumbs